import { PostAPI } from 'Components/Helper/Helpers';
 
export const Insert = async (request) => {
    return PostAPI(request, 'UserWiseLatLong/Insert');
};
 
export const Update = async (request) => {
    return PostAPI(request, 'UserWiseLatLong/Update');
};

export const SelectByID = async (request) => {
    return PostAPI(request, 'UserWiseLatLong/SelectByID');
};

export const Delete = async (request) => {
    return PostAPI(request, 'UserWiseLatLong/Delete');
};

export const Select = async (request) => {
    return PostAPI(request, 'UserWiseLatLong/Select');
};

